import { ValidatorFn, Validators } from '@angular/forms';

export const CustomValidatorFns: { [key: string]: ValidatorFn } = {
    required: Validators.required,
    requiredTrue: Validators.requiredTrue,
    email: Validators.pattern(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    ), // https://datatracker.ietf.org/doc/html/rfc5322
};
